
// to easily copy and paste components
import React from 'react';
import { withTranslation } from 'react-i18next';
import Parent from '../../../common/parent'
import {BllinkLogger} from "../../../common/utils/bllink_loggers";
import Confetti from "./confetti";
require('./rewards.css')


export class RewardsText extends Parent {

    constructor(props) {
        super(props);
        // only for main components
        // document.title = props.t('titles.search_building');
        BllinkLogger.info(`RewardsText props`, this.props);

    }

    isEligibleForReward(paymentResult){
        let onGoing = paymentResult.on_going_payments
        if (onGoing){
            return (
                onGoing.paymentsSortedArray.length > 0  &&
                onGoing.rewards
            )
        }
    }

    render() {
        const { t, payments } = this.props;
        const hidden = payments == null || !this.isEligibleForReward(payments);
        return (
            <div id="rewards-text" className={ hidden ? 'container hidden' : 'container'}>
                {/* todo make it dynamic*/}
                {/*<h4 className={'rewards_title'}>{t('rewards.entitled_first_month_50_off_campaign')}</h4>*/}
                <h4 className={'rewards_title'}>{t('rewards.entitled_first_month_30_off_campaign')}</h4>
                <Confetti/>
            </div>
        )
    }
}

export default withTranslation()(RewardsText);

